import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchNotifications = createAsyncThunk(
  "notifications/fetchNotifications",
  async ({ page = 1, audience = "", category = "", user_id = "" }, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      let url = `${BASE_URL}/dashboard/notifications?page=${page}`;
      if (audience) url += `&audience=${audience}`;
      if (category) url += `&category=${category}`;
      if (user_id) url += `&user_id=${user_id}`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Accept-Language": "ar",
        },
      });
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "فشل في تحميل الإشعارات";
      return rejectWithValue(message);
    }
  }
);

export const sendNotification = createAsyncThunk(
  "notifications/sendNotification",
  async (data, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.post(`${BASE_URL}/dashboard/notifications/send`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Accept-Language": "ar",
        },
      });
      return { ...response.data, message: response.data.message || "تم إرسال الإشعار بنجاح" };
    } catch (error) {
      const message = error.response?.data?.message || "فشل في إرسال الإشعار";
      return rejectWithValue(message);
    }
  }
);

const NotificationsSlice = createSlice({
  name: "notifications",
  initialState: {
    notifications: [],
    meta: null,
    loading: false,
    error: null,
    success: null,
  },
  reducers: {
    clearNotificationState: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.notifications = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(sendNotification.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(sendNotification.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
      })
      .addCase(sendNotification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearNotificationState } = NotificationsSlice.actions;
export default NotificationsSlice.reducer;
